const MUTATIONS = {

/* =====================================================================
	Config
	==================================================================== */

	SET_CONFIG_DATA: "global/api/setConfig",
	COMPLETE_CONFIG: "global/api/completeConfigLoad",

/* =====================================================================
	Preloader
	==================================================================== */

	SET_PRELOADER_PROGRESS: "global/assets/setProgress",
	SET_PRELOADER_STATUS: "global/assets/setStatus",

/* =====================================================================
	Game Status
	==================================================================== */

	START_GAME: "game/start",
	COMPLETE_GAME: "game/complete",
	PAUSE_GAME: "game/pause",
	UNPAUSE_GAME: "game/unpause",

/* =====================================================================
	Rounds
	==================================================================== */

	POPULATE_ROUNDS: "game/rounds/populate",
	SET_ROUND_INDEX: "game/rounds/setIndex",
	SET_SPIN_COUNT: "game/rounds/setSpinCount",
	SET_BONUS_STATUS: "game/rounds/setBonusStatus",

/* =====================================================================
	Bummers
	==================================================================== */

	SET_AVAILABLE_BUMMERS: "game/bummers/setAvailable",
	SET_BUMMER_COMPLETION: "game/bummers/setCompletion",
	SET_BUMMER_ACTIVATION: "game/bummers/setActivation",
	ANSWER_TRIVIA: "game/bummers/answerTrivia",
	INVOICE_BUMMER_ITEMS: "game/bummers/invoice",
	RESET_BUMMER_INVOICE: "game/bummers/reset",

/* =====================================================================
	Insurance
	==================================================================== */

	SET_INSURANCE_SHOP_STATE: "game/insurance/setPurchaseState",

/* =====================================================================
	Modal
	==================================================================== */

	ACTIVATE_MODAL_WINDOW: "global/modal/activate",
	DEACTIVATE_MODAL_WINDOW: "global/modal/deactivate",

/* =====================================================================
	Routes
	==================================================================== */

	ROUTE_CHANGED: "route/ROUTE_CHANGED",

/* =====================================================================
	Balance
	==================================================================== */

	SET_BALANCE: "game/balance/setBalance",

/* =====================================================================
	Hints
	==================================================================== */

	SET_HINT: "game/hints/set",
	CREATE_HINTS: "game/hints/create",

/* =====================================================================
	Insurance Plans
	==================================================================== */

	SET_PLAN_OWNERSHIP: "game/plans/setOwnership",
	SET_PLAN_SELECTION: "game/plans/toggleSelection",
	SET_COVERAGE_STATE_DATA: "game/plans/setCoverageStateData",

	TRACK_REFUND_STATE: "game/plans/setRefundState",
	SET_PLAN_ADDONS: "game/plans/setAddons",
	TRACK_LIMIT: "game/plans/trackLimit",
	SET_PAID_DEDUCTIBLE_AMOUNT: "game/plans/setPaidDeductible",
	SET_PAID_LIMIT_AMOUNT: "game/plans/setPaidLimit",
	SET_PAID_SUBLIMIT_AMOUNT: "game/plans/setPaidSublimit",

/* =====================================================================
	Risk
	==================================================================== */

	ADD_RISK_SCORE: "game/risk/add",

/* =====================================================================
	Coverages
	==================================================================== */

	SET_TRACKER_PAID: "setTrackerPaid",
	SET_TRACKER_TOPAY: "setTrackerToPay",
	SET_TRACKER_OVERAGE: "setTrackerOverage",
	SET_TRACKER_COVERAGEGAP: "setTrackerCoverageGap",


/* =====================================================================
	SOUND
	==================================================================== */

	TOGGLE_MUTE: "sound/toggle",
	CREATE_SOUND: "sound/create",
	REMOVE_SOUND: "sound/remove",
	CONTROL_SOUND: "sound/control",

	TRACK_SOUND: "sound/fx/track",
	UNTRACK_SOUND: "sound/fx/untrack",

	PLAY_MUSIC: "sound/music/play",
	PAUSE_MUSIC: "sound/music/stop",
	STOP_MUSIC: "sound/music/stop",
};

export const ROOT = MUTATIONS;
export const LOCAL = Object.entries(MUTATIONS)
	.map(([key, path]) => [key, /[^/]*$/.exec(path)])
	.reduce((obj, [key, value]) => ({ ...obj, [key]: value[0] }), {});

export const ROOT_FLAG = { root: true };
